import Constants from "@/infra/constants/constants";
import { Dictionary } from "vue-gtag";

export enum ChildCompanies {
  SUPER_OPA="SuperOpa",
  SUPER_MAXIMO="Super Máximo",
  DALBEN="Dalben",
  SUPER_MAXIMO_CUSTOM_PRICE="Super Máximo preço customizado",
}

export class ChildCompanyUtils {

  private static readonly childCompanyIds: Dictionary<{ dev: string, prod: string }> = {
    [ChildCompanies.SUPER_OPA]: {
      dev: "cda55fa1-e454-4b79-9223-ee9ebda13847",
      prod: "9a0b883f-c8a5-4254-b1c3-336851513762",
    },
    [ChildCompanies.SUPER_MAXIMO]: {
      dev: "3ef13f9c-8346-44db-ad1c-08f7ed8332c9",
      prod: "d376eebc-b9ed-4750-88c4-246cac09b074",
    },
    [ChildCompanies.DALBEN]: {
      dev: "5ada802c-3bf6-4678-8dc9-cc7cc6a7a9cd",
      prod: "8800cf13-030c-4e9b-8b2c-f674cda7fc58",
    },
    [ChildCompanies.SUPER_MAXIMO_CUSTOM_PRICE]: {
      dev: "e11f650f-b090-447f-a39e-653fe303b93e",
      prod: "e11f650f-b090-447f-a39e-653fe303b93e",
    },
  };

  static getChildCompanyId(childCompany: ChildCompanies): string {
    return ChildCompanyUtils.childCompanyIds[childCompany][Constants.stage];
  }

}